// extracted by mini-css-extract-plugin
export default {"testimonial":"Testimonial_testimonial__85XGM","titleRow":"Testimonial_titleRow__YTgbS","icon":"Testimonial_icon__YecZp"};